import { TranslationMap } from '../../../types/TranslationMap'

export type LiveEventCollection = {
  id: string
  gameId: string
  names: TranslationMap
  evolution: LiveEventEvolutionEntry[]
}

// in frontend we need to have a single start date for the evolution entry
export type LiveEventEvolutionEntry = {
  eventId: string
  types: LiveEventEvolutionTypeEnum[] | undefined
  name: string
  highlighted: boolean
  firstInstance: boolean
  mechanicChange: boolean
  descriptions: TranslationMap
  start: number
}

export type LiveEventCollectionDB = LiveEventCollection & {
  evolution: LiveEventEvolutionEntryDB[]
}

// in backend we need to have an array of start dates for the evolution entry
export type LiveEventEvolutionEntryDB = Omit<LiveEventEvolutionEntry, 'start'> & {
  start: LiveEventEvolutionEntryStart[]
}

export type LiveEventEvolutionEntryStart = {
  ts: number
  firstInstance: boolean
}

// NOTE: Highlighted & FirstAppearance are not supported by the backend
export enum LiveEventEvolutionTypeEnum {
  Highlighted = 'HIGHLIGHTED',
  Reskin = 'RESKIN',
  MechanicChange = 'MECHANIC_CHANGE',
  FirstInstanceSeen = 'FIRST_INSTANCE_SEEN',
}
